import { useCallback, useEffect, useState, useRef, useMemo } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import ChukkerList from "../components/Chukkers/ChukkerList";
import ChukkerListDense from "../components/Chukkers/ChukkerListDense";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  LinearProgress,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  ToggleButton,
  ToggleButtonGroup,
  Alert,
  AlertTitle,
  Box,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import classes from "../components/Chukkers/PlayerItem.module.css";
import DashboardTabs from "../components/ui/DashboardTabs";
import Layout from "../components/layout/Layout";
import useRefresh from "../components/Refresh/refresh";
import SaveIcon from "@mui/icons-material/Save";
import DownloadIcon from "@mui/icons-material/Download";
import SyncIcon from "@mui/icons-material/Sync";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import SavePromptModal from "../components/ui/SavePromptModal";
import EmailIcon from "@mui/icons-material/Email";
import PRO_COLORS from "./proColors";
import getProMapping from "../components/Signups/getProMapping";
import NoEmailModal from "../components/Chukkers/NoEmailModal";
import EmailBodyModal from "../components/Chukkers/EmailBodyModal";
import UnifiedSpreadsheet from "src/components/Chukkers/UnifiedSpreadhseet";
import poloMalletLogo from "../components/Chukkers/PoloTest.png";

//<PlayerList chukkerList={DUMMY_DATA} />

function MatchupPage({
  eventId,
  clubId,
  gameDate,
  devPort,
  waiverNotifications,
  managerMode,
  gamePoloType,
  betaMode,
  gameDivisions,
}) {
  useRefresh(clubId, devPort);
  const [listOfChukkers, setListofChukkers] = useState();
  const [listOfChukkersReference, setListofChukkersReference] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [useUSPARating, setUseUSPARating] = useState(false);
  const [noMatchup, setNoMatchup] = useState(false);
  const [spreadsheetView, setSpreadsheetView] = useState(false);
  const [useNewDashboard] = useState(true);
  const [playerSchedule, setPlayerSchedule] = useState();
  const [outputSchedule, setOutputSchedule] = useState();
  const [chukkerNumber, setChukkerNumber] = useState(0);
  const [idMapping, setIdMapping] = useState();
  const [spreadsheetBench, setSpreadsheetBench] = useState([]);
  const [matchupAlgo, setMatchupAlgo] = useState("PRO");
  const [advancedSettings, setAdvancedSettings] = useState(false);
  const [chukkerDetails, setChukkerDetails] = useState({});
  const [proMapping, setProMapping] = useState();
  const [mailingList, setMailingList] = useState("");
  const [unifiedSpreadsheetData, setUnifiedSpreadsheetData] = useState([]);
  // Cache for horse assignments and player horses to avoid duplicate API calls
  const [allHorseAssignments, setAllHorseAssignments] = useState({}); // { playerId: assignments[] }
  const [allPlayerHorses, setAllPlayerHorses] = useState({}); // { playerId: horses[] }
  const [allClubHorses, setAllClubHorses] = useState([]);
  const [horseDataLoaded, setHorseDataLoaded] = useState(false); // Flag to prevent re-loading
  const listOfChukkersRef = useRef(listOfChukkers); // Ref to track current listOfChukkers without causing re-renders
  
  // Update ref when listOfChukkers changes
  useEffect(() => {
    listOfChukkersRef.current = listOfChukkers;
  }, [listOfChukkers]);
  const getMailingList = useCallback(() => {
    const fetch_mailing_list = devPort + "club_mailing_list/" + clubId;
    console.log(fetch_mailing_list);
    fetch(fetch_mailing_list, { credentials: "include" })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("Mailing List");
        if (data && data[0]) {
          console.log(data[0][0]);
          setMailingList(data[0][0]);
        }
      });
  }, [devPort, clubId]);

  useEffect(() => {
    const player_fetcher = devPort + "player_list/" + clubId + "/True";
    getProMapping(
      devPort,
      player_fetcher,
      setProMapping,
      () => {},
      () => {} //setLoadingClubPros
    );
    getMailingList();
  }, [devPort, clubId, getMailingList]);
  const [proColorMapping, setProColorMapping] = useState();
  const loadPlayers = useCallback(() => {
    console.log(devPort + "player_roster/" + clubId + "/" + eventId);
    fetch(devPort + "player_roster/" + clubId + "/" + eventId, {
      credentials: "include",
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        const newProColorMapping = {};
        const newPlayerPros = {};
        let colorIndex = 0;
        data.map((player) => {
          newPlayerPros[player[0]] = player[7];
          if (
            (player[7] && !newProColorMapping[player[7]]) ||
            (player[8] && !newProColorMapping[player[0]])
          ) {
            const player_index_mapping = { 7: 7, 8: 0 };
            Object.keys(player_index_mapping).map((index) => {
              if (
                player[index] &&
                !newProColorMapping[player[player_index_mapping[index]]]
              ) {
                newProColorMapping[player[player_index_mapping[index]]] =
                  PRO_COLORS[colorIndex];
                if (colorIndex === PRO_COLORS.length - 1) {
                  colorIndex = 0;
                } else {
                  colorIndex += 1;
                }
              }
              return null;
            });
          }
          return null;
        });
        setProColorMapping({
          PROS: newProColorMapping,
          PLAYERS: newPlayerPros,
          MAPPING: proMapping,
        });
        console.log("CHECK PRO COLOR MAPPING");
        console.log(newProColorMapping);
      });
  }, [devPort, clubId, eventId, proMapping]);

  useEffect(() => {
    if (proMapping) {
      loadPlayers();
    }
  }, [proMapping, loadPlayers]);

  const getMatchupFromApi = useCallback(
    (matchup, matchupAlgo, useUSPARating) => {
      setIsLoading(true);
      let matchup_call = devPort + matchup + "/";
      if (matchup === "load_saved_matchup") {
        matchup_call = matchup_call + eventId;
      } else {
        const pullRating = useUSPARating ? "uspa" : "club";
        matchup_call =
          matchup_call +
          clubId +
          "/" +
          eventId +
          "/" +
          gameDate +
          "/" +
          pullRating +
          "/" +
          matchupAlgo +
          "/" +
          gamePoloType;
      }

      console.log(matchup_call);
      fetch(matchup_call, { credentials: "include" })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data);
          if (data[0] && Object.keys(data[0]).length !== 0) {
            console.log("GENERATE MATCHUP IS");
            console.log(data[0]);
            //Does not do deep copy
            let newSchedule = data[0];
            let newSpreadsheetBench = [];
            if (-1 in data[0]) {
              Object.keys(data[0]).forEach((keys) => {
                if (keys < -1) {
                  console.log("MY KEYS");
                  console.log(keys);
                  console.log(
                    Object.keys(data[0][keys]["A_" + keys.toString()])
                  );
                  Object.keys(data[0][keys]["A_" + keys.toString()]).forEach(
                    (playerNumber) => {
                      newSchedule[-1]["A_-1"][playerNumber] =
                        data[0][keys]["A_" + keys.toString()][playerNumber];
                    }
                  );
                  delete newSchedule[keys];
                }
              });
              Object.keys(data[0][-1]["A_-1"]).forEach((playerNumber) => {
                const playerSave = {
                  game_id: eventId,
                  chukker_id: data[0][-1]["A_-1"][playerNumber][1],
                  team_id: "A", //listOfChukkers[chukkerId][team][playerId][2],
                  player_id: data[0][-1]["A_-1"][playerNumber][3].toString(),
                };
                newSpreadsheetBench.push(playerSave);
              });
            } else {
              newSchedule[-1] = {};
              newSchedule[-1]["A_-1"] = {};
            }

            console.log("CURRENT BENCH");
            console.log(newSpreadsheetBench);
            setSpreadsheetBench(newSpreadsheetBench);
            setListofChukkers(newSchedule);
            setPlayerSchedule(data[1]);
            setOutputSchedule(data[2]);
            setChukkerNumber(data[3]);
            setIdMapping(data[4]);
            setChukkerDetails(data[5]);
            setUnifiedSpreadsheetData(data[6]);

            if (matchup === "load_saved_matchup") {
              setListofChukkersReference(data[0]);
            }
            setIsLoading(false);
          } else {
            if (matchup === "load_saved_matchup") {
              if (managerMode === -1) {
                console.log(
                  "No matchup found in the DB. Generating matchup..."
                );
                getMatchupFromApi(
                  "generate_matchup_strategy",
                  matchupAlgo,
                  useUSPARating
                );
              } else {
                console.log("No matchup found in the DB");
                setNoMatchup(true);
                setIsLoading(false);
              }
            } else {
              console.log("No matchup available");
              setNoMatchup(true);
              setIsLoading(false);
            }
          }
        });
    },
    [devPort, eventId, gameDate, managerMode, clubId, gamePoloType]
  );
  useEffect(() => {
    getMatchupFromApi("load_saved_matchup");
  }, [spreadsheetView, getMatchupFromApi]);

  function moveTeam(id_sender, chukker_sender, id_receiver) {
    console.log(id_sender);
    console.log(id_receiver);
    console.log(chukker_sender);
    var newChukkerList = { ...listOfChukkers };
    console.log(newChukkerList);
    const movingTeam = newChukkerList[chukker_sender][id_sender];
    delete newChukkerList[chukker_sender][id_sender];
    newChukkerList[id_receiver][id_sender] = movingTeam;
    setListofChukkers(newChukkerList);
  }
  function swapTeam(chukker_sender, id_sender, chukker_receiver, id_receiver) {
    console.log(id_sender);
    console.log(id_receiver);
    console.log(chukker_sender);
    var newChukkerList = { ...listOfChukkers };
    console.log(newChukkerList);
    const movingTeamFrom = newChukkerList[chukker_sender][id_sender];
    const movingTeamTo = newChukkerList[chukker_receiver][id_receiver];
    delete newChukkerList[chukker_sender][id_sender];
    delete newChukkerList[chukker_receiver][id_receiver];
    //newChukkerList[chukker_receiver]["teams"][id_sender] = movingTeamFrom;
    //newChukkerList[chukker_sender]["teams"][id_receiver] = movingTeamTo;
    newChukkerList[chukker_sender][id_sender] = movingTeamTo;
    newChukkerList[chukker_receiver][id_receiver] = movingTeamFrom;
    console.log("CHECKER CHECKMATE")
    console.log(movingTeamFrom)
    console.log(movingTeamTo)
    setListofChukkers(newChukkerList);
    // Horse assignments are stored in player data objects, so they move with the teams automatically
  }

  function movePlayer(
    id_sender,
    chukker_sender,
    team_sender,
    id_receiver,
    chukker_receiver
  ) {
    console.log(id_sender);
    console.log(id_receiver);
    console.log(chukker_sender);
    console.log(team_sender);
    const newChukkerList = { ...listOfChukkers };
    const movingPlayer = newChukkerList[chukker_sender][team_sender][id_sender];
    
    // If moving to bench, remove horse assignment from player data
    const newChukkerStr = String(chukker_receiver);
    if (newChukkerStr === "-1" && movingPlayer) {
      // Remove horse assignment from both horseId property and array index 11
      if (movingPlayer.horseId) {
        delete movingPlayer.horseId;
      }
      // Also clear index 11 (assigned_horse) if it's an array
      if (Array.isArray(movingPlayer) && movingPlayer.length > 11) {
        movingPlayer[11] = null;
      }
    }
    
    delete newChukkerList[chukker_sender][team_sender][id_sender];
    console.log("MOVING PLAYE CHECKAMTE");
    console.log(movingPlayer);
    newChukkerList[chukker_receiver][id_receiver][id_sender] = movingPlayer;
    console.log(newChukkerList);
    setListofChukkers(newChukkerList);
    // Horse assignment is now stored in movingPlayer.horseId, so it moves with the player automatically
  }
  console.log(listOfChukkers);
  //TODO dnd messes up the new chukkers
  function createChukker() {
    const newChukkerList = { ...listOfChukkers };
    //const chukkerNumber = Object.keys(newChukkerList).length;
    console.log(chukkerNumber);
    newChukkerList[chukkerNumber + 1] = {};
    newChukkerList[chukkerNumber + 1] = {};
    newChukkerList[chukkerNumber + 1]["A_" + (chukkerNumber + 1)] = {};
    newChukkerList[chukkerNumber + 1]["B_" + (chukkerNumber + 1)] = {};
    setChukkerNumber(chukkerNumber + 1);
    setListofChukkers(newChukkerList);
    setChukkerDetails((prev) => ({
      ...prev,
      [chukkerNumber + 1]: {
        jersey_color: {
          A: "blue",
          B: "red",
        },
        division_name: null,
      },
    }));
  }
  function deleteChukker() {
    const newChukkerList = { ...listOfChukkers };
    //-1 to exclude the bench
    const chukkerNumber = Object.keys(newChukkerList).length - 1;
    delete newChukkerList[chukkerNumber];
    setChukkerNumber(chukkerNumber - 1);
    setListofChukkers(newChukkerList);
    setChukkerDetails((prev) => {
      const newChukkerDetails = { ...prev };
      delete newChukkerDetails[chukkerNumber];
      return newChukkerDetails;
    });
  }
  function moveSpreadSheet(playerName, team, sourceIndex, destinationIndex) {
    if (playerSchedule[team][playerName][destinationIndex] !== "x") {
      console.log(playerSchedule[team][playerName]);
      console.log(playerSchedule[team][playerName][sourceIndex]);
      console.log(playerSchedule[team][playerName][destinationIndex]);
      playerSchedule[team][playerName][destinationIndex] = "x";
      playerSchedule[team][playerName][sourceIndex] = "";
    }
  }
  function moveSpreadSheetPlayer(playerName, teamOrigin, teamDestination) {
    const player = playerSchedule[teamOrigin][playerName];
    delete playerSchedule[teamOrigin][playerName];
    if (playerName in playerSchedule[teamDestination]) {
      console.log("CONFUSED");
      console.log(player);
      let index = 0;
      let newPlayer = playerSchedule[teamDestination][playerName];
      while (index < player.length) {
        if (player[index] === "x") {
          newPlayer[index] = "x";
        }
        index += 1;
      }
      playerSchedule[teamDestination][playerName] = newPlayer;
    } else {
      playerSchedule[teamDestination][playerName] = player;
    }
  }

  function dropData(result) {
    console.log(result);
    console.log(result.type);
    console.log(result.source);
    console.log(result.destination);
    const sender_info = result.source.droppableId.split("____");
    const receiver_info = result.destination.droppableId.split("____");
    if (result.type === "TEAM") {
      // Extract playerId from draggableId format: chukker____team____playerId
      const draggableIdParts = result.draggableId.split("____");
      const playerId = draggableIdParts.length === 3 ? draggableIdParts[2] : result.draggableId;
      movePlayer(
        playerId,
        sender_info[0],
        sender_info[1],
        receiver_info[1],
        receiver_info[0]
      );
    }
    if (result.type === "CHUKKER") {
      swapTeam(
        sender_info[0],
        sender_info[1],
        receiver_info[0],
        receiver_info[1]
      );
    }

    if (result.type.startsWith("SPREADSHEET_X")) {
      if (result.source.droppableId === result.destination.droppableId) {
        moveSpreadSheet(
          sender_info[1],
          sender_info[0],
          result.source.index,
          result.destination.index
        );
      }
    }
    if (result.type === "SPREADSHEET_TEAM_SWAP") {
      console.log("HELLO");
      console.log(result.draggableId.split("____")[1]);
      console.log(sender_info[0]);
      console.log(receiver_info[0]);
      moveSpreadSheetPlayer(
        result.draggableId.split("____")[1],
        sender_info[0],
        receiver_info[0]
      );
    }

    // Handle unified spreadsheet drag and drop
    if (
      result.source.droppableId.startsWith("chukker-") ||
      result.destination.droppableId.startsWith("chukker-")
    ) {
      const [playerId, sourceChukker] = result.draggableId.split("-");
      const destChukker = result.destination.droppableId.split("-")[1];

      // Create new data array
      const newData = [...unifiedSpreadsheetData];

      // Remove from source
      newData[parseInt(sourceChukker)][playerId] = "";

      // Add to destination with appropriate team
      const team =
        sourceChukker === destChukker
          ? newData[parseInt(sourceChukker)][playerId] === "x"
            ? "o"
            : "x"
          : newData[parseInt(sourceChukker)][playerId] === "x"
          ? "x"
          : "o";

      newData[parseInt(destChukker)][playerId] = team;

      setUnifiedSpreadsheetData(newData);
    }
  }
  let currentPage = "/matchup";
  if (managerMode !== -1) {
    currentPage = "/playermatchup";
  }
  useRefresh(clubId, devPort);
  function saveToDb() {
    console.log("Saving to Database...");
    console.log(spreadsheetBench);
    let playerSaveList = [];
    if (spreadsheetView) {
      // Iterate through each chukker in unifiedSpreadsheetData
      Object.keys(unifiedSpreadsheetData).forEach((playerId) => {
        // Iterate through each player in the chukker
        unifiedSpreadsheetData[playerId].map((chukkerData, chukkerIndex) => {
          if (chukkerData === "x" || chukkerData === "o") {
            // Try to find the player data to get horse assignment
            let assignedHorse = null;
            const chukkerStr = String(chukkerIndex + 1);
            const teamStr = chukkerData === "x" ? "A" : "B";
            if (listOfChukkers && listOfChukkers[chukkerStr] && listOfChukkers[chukkerStr][teamStr + "_" + chukkerStr]) {
              Object.keys(listOfChukkers[chukkerStr][teamStr + "_" + chukkerStr]).forEach((playerKey) => {
                const playerData = listOfChukkers[chukkerStr][teamStr + "_" + chukkerStr][playerKey];
                if (playerData && (playerData[3] === parseInt(playerId) || String(playerData[3]) === playerId)) {
                  // Get horse from playerData.horseId or from array index 11
                  assignedHorse = playerData.horseId || (Array.isArray(playerData) && playerData.length > 11 ? playerData[11] : null);
                }
              });
            }
            
            const playerSave = {
              game_id: eventId,
              chukker_id: chukkerIndex + 1,
              team_id: chukkerData === "x" ? "A" : "B",
              player_id: playerId,
              division_name: chukkerDetails[chukkerIndex + 1]?.division_name,
              jersey_color:
                chukkerDetails[chukkerIndex + 1]?.jersey_color[
                  chukkerData === "x" ? "A" : "B"
                ],
              assigned_horse: assignedHorse,
            };
            playerSaveList.push(playerSave);
          }
          return null;
        });
      });
      playerSaveList = playerSaveList.concat(spreadsheetBench);
    } else {
      let playerBenchMapping = {};
      Object.keys(listOfChukkers).map((chukkerId) => {
        let playerBenchMappingCurrentChukker = {};
        Object.keys(listOfChukkers[chukkerId]).map((team) => {
          Object.keys(listOfChukkers[chukkerId][team]).map((playerId) => {
            let newChukkerId = chukkerId;
            let newTeamId = team.split("_")[0];
            console.log(chukkerId);
            console.log(listOfChukkers[chukkerId][team][playerId]);
            //Check for all chukkerId to avoid deletion if duplicate player in random chukker
            if (
              listOfChukkers[chukkerId][team][playerId][3] in
                playerBenchMappingCurrentChukker ||
              chukkerId === "-1"
            ) {
              newTeamId = "A";
              if (
                listOfChukkers[chukkerId][team][playerId][3] in
                playerBenchMapping
              ) {
                newChukkerId =
                  playerBenchMapping[
                    listOfChukkers[chukkerId][team][playerId][3]
                  ];
                playerBenchMapping[
                  listOfChukkers[chukkerId][team][playerId][3]
                ] -= 1;
              } else {
                newChukkerId = -1;
                playerBenchMapping[
                  listOfChukkers[chukkerId][team][playerId][3]
                ] = -2;
              }
            } else {
              playerBenchMappingCurrentChukker[
                listOfChukkers[chukkerId][team][playerId][3]
              ] = true;
            }
            console.log(newChukkerId);
            const playerData = listOfChukkers[chukkerId][team][playerId];
            // Get horse assignment from playerData.horseId or from array index 11
            // If player is on bench (newChukkerId === -1), set assigned_horse to null
            let assignedHorse = null;
            if (newChukkerId !== -1) {
              assignedHorse = playerData.horseId || (Array.isArray(playerData) && playerData.length > 11 ? playerData[11] : null);
            }
            
            const playerSave = {
              game_id: eventId,
              chukker_id: newChukkerId,
              team_id: newTeamId, //listOfChukkers[chukkerId][team][playerId][2],
              player_id: playerData[3],
              division_name: chukkerDetails[newChukkerId]?.division_name,
              jersey_color:
                chukkerDetails[newChukkerId]?.jersey_color?.[newTeamId],
              assigned_horse: assignedHorse,
            };
            playerSaveList.push(playerSave);
            //console.log(playerSave);
            //console.log(listOfChukkers[chukkerId][team][playerId]);
            return null;
          });
          return null;
        });
        return null;
      });
    }

    const saveCall = devPort + "store_daily_games/" + eventId;
    console.log(saveCall);
    console.log(playerSaveList);
    /*const text = {
      operation:"insert"
  }*/
    fetch(saveCall, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(playerSaveList),
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      console.log("Matchup Saved to DB");
      
      // Save horse assignments from player data objects
      const horseAssignmentsList = [];
      Object.keys(listOfChukkers).forEach((chukkerId) => {
        if (chukkerId !== "-1") {
          const chukkerNum = parseInt(chukkerId);
          Object.keys(listOfChukkers[chukkerId]).forEach((team) => {
            Object.keys(listOfChukkers[chukkerId][team]).forEach((playerKey) => {
              const playerData = listOfChukkers[chukkerId][team][playerKey];
              if (playerData && playerData[3] && playerData.horseId) {
                horseAssignmentsList.push({
                  club_id: clubId,
                  event_type: "games",
                  event_id: eventId,
                  player_id: playerData[3],
                  chukker: chukkerNum,
                  horse_id: playerData.horseId,
                });
              }
            });
          });
        }
      });
      
      if (horseAssignmentsList.length > 0) {
        fetch(devPort + "horses/assign-chukker", {
          method: "POST",
          credentials: "include",
          body: JSON.stringify(horseAssignmentsList),
          headers: {
            "Content-Type": "application/json",
          },
        }).then(() => {
          console.log("Horse assignments saved");
        }).catch(() => {
          console.log("Failed to save horse assignments");
        });
      }
      
      getMatchupFromApi("load_saved_matchup");
      return response.json();
    });
    console.log("Switching View");
    setSpreadsheetView(true);
  }
  
  // Load all horse assignments and player horses once to avoid duplicate API calls
  const loadAllHorseData = useCallback(() => {
    const currentChukkers = listOfChukkersRef.current;
    if (!devPort || !clubId || !eventId || !currentChukkers || horseDataLoaded) {
      return;
    }
    
    setHorseDataLoaded(true); // Set flag to prevent re-loading
    
    // Get all unique player IDs from the matchup
    const playerIds = new Set();
    const playerChukkerMap = new Map(); // { playerId: { chukker: playerData } }
    Object.keys(currentChukkers).forEach((chukkerId) => {
      if (chukkerId !== "-1") {
        Object.keys(currentChukkers[chukkerId]).forEach((team) => {
          Object.keys(currentChukkers[chukkerId][team]).forEach((playerKey) => {
            const playerData = currentChukkers[chukkerId][team][playerKey];
            if (playerData && playerData[3]) {
              const playerId = String(playerData[3]);
              playerIds.add(playerId);
              if (!playerChukkerMap.has(playerId)) {
                playerChukkerMap.set(playerId, {});
              }
              playerChukkerMap.get(playerId)[chukkerId] = playerData;
            }
          });
        });
      }
    });
    
    // Load all assignments for the event at once
    const allAssignmentsPromise = fetch(
      `${devPort}horses/assignments/${clubId}/games/${eventId}`,
      { credentials: "include" }
    )
      .then((response) => response.json())
      .then((data) => Array.isArray(data) ? data : [])
      .catch(() => []);
    
    // Load club horses once
    const clubHorsesPromise = fetch(`${devPort}horses/${clubId}`, {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => Array.isArray(data) ? data.filter((h) => h.status === "available") : [])
      .catch(() => []);
    
    // Load player horses for all players (batch)
    const playerHorsesPromises = Array.from(playerIds).map((playerId) =>
      fetch(`${devPort}horses/user/${playerId}`, {
        credentials: "include",
      })
        .then((response) => response.json())
        .then((data) => ({ playerId, horses: Array.isArray(data) ? data.filter((h) => h.status === "available") : [] }))
        .catch(() => ({ playerId, horses: [] }))
    );
    
    Promise.all([allAssignmentsPromise, clubHorsesPromise, ...playerHorsesPromises]).then(([allAssignments, clubHorses, ...playerHorsesResults]) => {
      // Build assignments map by player
      const assignmentsByPlayer = {};
      allAssignments.forEach((assignment) => {
        const playerId = String(assignment.player_id);
        if (!assignmentsByPlayer[playerId]) {
          assignmentsByPlayer[playerId] = [];
        }
        assignmentsByPlayer[playerId].push(assignment);
      });
      
      // Build player horses map
      const playerHorsesMap = {};
      playerHorsesResults.forEach(({ playerId, horses }) => {
        playerHorsesMap[playerId] = horses;
      });
      
      setAllHorseAssignments(assignmentsByPlayer);
      setAllPlayerHorses(playerHorsesMap);
      setAllClubHorses(clubHorses);
      
      // Store horse assignments in player data objects using functional update to avoid dependency issues
      setListofChukkers((prevChukkers) => {
        const newChukkerList = { ...prevChukkers };
        Object.keys(assignmentsByPlayer).forEach((playerId) => {
          const assignments = assignmentsByPlayer[playerId];
          const playerChukkers = playerChukkerMap.get(playerId);
          if (playerChukkers && assignments.length > 0) {
            assignments.forEach((assignment) => {
              if (assignment.chukker_numbers && Array.isArray(assignment.chukker_numbers)) {
                assignment.chukker_numbers.forEach((chukkerNum) => {
                  const chukkerStr = String(chukkerNum);
                  // Find the player data in the new chukker list
                  if (newChukkerList[chukkerStr]) {
                    Object.keys(newChukkerList[chukkerStr]).forEach((teamId) => {
                      const team = newChukkerList[chukkerStr][teamId];
                      if (team) {
                        Object.keys(team).forEach((playerKey) => {
                          const playerData = team[playerKey];
                          if (playerData && playerData[3] && String(playerData[3]) === playerId) {
                            playerData.horseId = assignment.horse_id;
                          }
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
        return newChukkerList;
      });
    });
  }, [devPort, clubId, eventId, horseDataLoaded]); // Removed listOfChukkers from dependencies

  // Load all horse data when matchup data is loaded (only once)
  useEffect(() => {
    if (listOfChukkers && Object.keys(listOfChukkers).length > 0 && !isLoading && !horseDataLoaded) {
      loadAllHorseData();
    }
  }, [listOfChukkers, isLoading, horseDataLoaded, loadAllHorseData]);
  
  // Reset horse data loaded flag when eventId changes
  useEffect(() => {
    setHorseDataLoaded(false);
    setAllHorseAssignments({});
    setAllPlayerHorses({});
    setAllClubHorses([]);
  }, [eventId]);

  // Callback to update horse assignment - store it in the player data object
  const updateHorseAssignment = useCallback((playerId, chukker, horseId) => {
    if (!listOfChukkers) return;
    
    // Find the player in the chukker and update their horse assignment
    const newChukkerList = { ...listOfChukkers };
    const chukkerStr = String(chukker);
    
    // Search through all teams in this chukker to find the player
    if (newChukkerList[chukkerStr]) {
      Object.keys(newChukkerList[chukkerStr]).forEach((teamId) => {
        const team = newChukkerList[chukkerStr][teamId];
        if (team) {
          Object.keys(team).forEach((playerKey) => {
            const playerData = team[playerKey];
            // Check if this is the right player (playerData[3] is the player ID)
            if (playerData && playerData[3] && String(playerData[3]) === String(playerId)) {
              // Store horse assignment in both the horseId property and index 11 (assigned_horse)
              if (horseId) {
                playerData.horseId = horseId;
                // Also update index 11 if it's an array
                if (Array.isArray(playerData) && playerData.length > 11) {
                  playerData[11] = horseId;
                }
              } else {
                // Unassign: remove horseId property and set index 11 to null
                delete playerData.horseId;
                // Also clear index 11 if it's an array
                if (Array.isArray(playerData) && playerData.length > 11) {
                  playerData[11] = null;
                }
              }
            }
          });
        }
      });
    }
    
    setListofChukkers(newChukkerList);
  }, [listOfChukkers]);

  // Check for duplicate players and horses in each chukker
  const duplicateWarnings = useMemo(() => {
    if (!listOfChukkers || managerMode !== -1) return { duplicatePlayers: [], duplicateHorses: [] };
    
    const duplicatePlayers = [];
    const duplicateHorses = [];
    
    // Iterate through each chukker (exclude bench: chukkerId === "-1")
    Object.keys(listOfChukkers).forEach((chukkerId) => {
      if (chukkerId === "-1") return; // Skip bench
      
      const chukker = listOfChukkers[chukkerId];
      const playerIds = new Map(); // Map of playerId -> count
      const horseIds = new Map(); // Map of horseId -> count
      const playerNames = new Map(); // Map of playerId -> name for display
      const horseNames = new Map(); // Map of horseId -> name for display
      
      // Iterate through all teams in this chukker
      Object.keys(chukker).forEach((teamId) => {
        const team = chukker[teamId];
        if (team) {
          Object.keys(team).forEach((playerKey) => {
            const playerData = team[playerKey];
            if (playerData && playerData[3]) {
              const playerId = String(playerData[3]);
              const playerName = `${playerData[4] || ""} ${playerData[5] || ""}`.trim() || `Player ${playerId}`;
              
              // Track player occurrences
              const currentCount = playerIds.get(playerId) || 0;
              playerIds.set(playerId, currentCount + 1);
              if (!playerNames.has(playerId)) {
                playerNames.set(playerId, playerName);
              }
              
              // Track horse occurrences
              const horseId = playerData.horseId || (Array.isArray(playerData) && playerData.length > 11 ? playerData[11] : null);
              if (horseId) {
                const horseIdStr = String(horseId);
                const currentHorseCount = horseIds.get(horseIdStr) || 0;
                horseIds.set(horseIdStr, currentHorseCount + 1);
                
                // Try to get horse name from allClubHorses or allPlayerHorses
                if (!horseNames.has(horseIdStr)) {
                  let horseName = `Horse ${horseIdStr}`;
                  // Check club horses
                  const clubHorse = allClubHorses.find(h => String(h.id) === horseIdStr);
                  if (clubHorse) {
                    horseName = clubHorse.name;
                  } else {
                    // Check player horses
                    Object.values(allPlayerHorses).forEach(playerHorses => {
                      const playerHorse = playerHorses.find(h => String(h.id) === horseIdStr);
                      if (playerHorse) {
                        horseName = playerHorse.name;
                      }
                    });
                  }
                  horseNames.set(horseIdStr, horseName);
                }
              }
            }
          });
        }
      });
      
      // Check for duplicate players
      playerIds.forEach((count, playerId) => {
        if (count > 1) {
          duplicatePlayers.push({
            chukkerId,
            playerId,
            playerName: playerNames.get(playerId),
            count,
          });
        }
      });
      
      // Check for duplicate horses
      horseIds.forEach((count, horseId) => {
        if (count > 1) {
          duplicateHorses.push({
            chukkerId,
            horseId,
            horseName: horseNames.get(horseId),
            count,
          });
        }
      });
    });
    
    return { duplicatePlayers, duplicateHorses };
  }, [listOfChukkers, managerMode, allClubHorses, allPlayerHorses]);
  function goToSpreadsheet() {
    setSpreadsheetView(!spreadsheetView);
  }
  const [navigateModal, setNavigateModal] = useState(false);
  function emailMembersWrapper() {
    if (!mailingList) {
      setNoEmailModal(true);
    } else {
      setEmailBodyModal(true);
    }
  }
  function emailMembers() {
    const emailCall = devPort + "email_daily_games";
    console.log(emailCall);
    console.log(chukkerNumber);
    fetch(emailCall, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({
        clubId: clubId,
        eventId: eventId, // Add eventId for horse assignment fetching
        schedule: unifiedSpreadsheetData, // playerSchedule,
        mapping: idMapping,
        chukkerNumber: chukkerNumber,
        emailBody: emailBody,
        gameDate: gameDate,
        chukkerDetails: chukkerDetails,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      console.log("Email Sent");
      return response.json;
    });
  }
  const [noEmailModal, setNoEmailModal] = useState(false);
  const [emailBodyModal, setEmailBodyModal] = useState(false);
  const [emailBody, setEmailBody] = useState("");

  return (
    <Layout
      managerMode={managerMode}
      waiverNotifications={waiverNotifications}
      devPort={devPort}
    >
      <DashboardTabs
        currentPage={currentPage}
        managerMode={managerMode}
        toReload={listOfChukkers !== listOfChukkersReference}
        saveToDb={saveToDb}
        gameMode="game"
      />
      <SavePromptModal
        navigateModal={navigateModal}
        setNavigateModal={setNavigateModal}
        navigateModalFunc={goToSpreadsheet}
        saveToDb={saveToDb}
      />
      <NoEmailModal
        navigateModal={noEmailModal}
        setNavigateModal={setNoEmailModal}
      />
      <EmailBodyModal
        navigateModal={emailBodyModal}
        setNavigateModal={setEmailBodyModal}
        emailBody={emailBody}
        setEmailBody={setEmailBody}
        emailMembers={emailMembers}
      />
      <DragDropContext onDragEnd={dropData}>
        <Stack spacing={2}>
          <Card data-testid="matchup-card">
            <CardContent>
              <h1 className={classes.contenth}>Game Matchup </h1>

              {/*<CarousselDuties
                devPort={devPort}
                clubId={clubId}
                listOfChukkers={listOfChukkers}
              />*/}

              <Stack spacing={2}>
                <ToggleButtonGroup
                  color="secondary"
                  value={spreadsheetView ? "spreadsheet" : "chukker"}
                  exclusive
                  fullWidth={true}
                  aria-label="View"
                >
                  <ToggleButton
                    value="chukker"
                    data-testid="switch-view-chukker"
                    onClick={() => setSpreadsheetView(false)}
                  >
                    Chukker View
                  </ToggleButton>
                  <ToggleButton
                    value="spreadsheet"
                    data-testid="switch-view-spreadsheet"
                    onClick={() => {
                      if (listOfChukkers !== listOfChukkersReference) {
                        setNavigateModal(true);
                      } else {
                        setSpreadsheetView(true);
                      }
                    }}
                  >
                    Spreadsheet View
                  </ToggleButton>
                </ToggleButtonGroup>
                {managerMode === -1 && (
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 4 }}>
                      <Button
                        variant="outlined"
                        data-testid="save-chukkers"
                        style={{ width: "100%" }}
                        onClick={saveToDb}
                      >
                        <SaveIcon />
                        Save
                      </Button>
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                      <Button
                        variant="outlined"
                        data-testid="export-chukkers"
                        style={{ width: "100%" }}
                        href={`data:text/json;charset=utf-8,${encodeURIComponent(
                          outputSchedule //JSON.stringify(playerSchedule)
                        )}`}
                        download="matchup.csv"
                      >
                        <DownloadIcon />
                        Export
                      </Button>
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                      <Button
                        variant="outlined"
                        data-testid="email-chukkers"
                        style={{ width: "100%" }}
                        onClick={emailMembersWrapper}
                      >
                        <EmailIcon />
                        Email
                      </Button>
                    </Grid>
                  </Grid>
                )}
                {/*!spreadsheetView && managerMode === -1 && (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={useNewDashboard}
                        data-testid="new-dashboard-toggle"
                        onChange={() => setUseNewDashboard(!useNewDashboard)}
                      />
                    }
                    label="New Dashboard"
                  />
                )*/}
                {!spreadsheetView && managerMode === -1 && (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={advancedSettings}
                        data-testid="advanced-settings"
                        onChange={() => setAdvancedSettings(!advancedSettings)}
                      />
                    }
                    label="Advanced Settings"
                  />
                )}
                {!spreadsheetView && managerMode === -1 && advancedSettings && (
                  <ToggleButtonGroup
                    color="secondary"
                    value={useUSPARating ? "uspa" : "club"}
                    exclusive
                    fullWidth={true}
                    aria-label="View"
                  >
                    <ToggleButton
                      value="club"
                      data-testid="switch-rating-club"
                      onClick={() => setUseUSPARating(false)}
                    >
                      Club Rating
                    </ToggleButton>
                    <ToggleButton
                      value="uspa"
                      data-testid="switch-rating-uspa"
                      onClick={() => setUseUSPARating(true)}
                    >
                      USPA Rating
                    </ToggleButton>
                  </ToggleButtonGroup>
                )}
                {!spreadsheetView && managerMode === -1 && advancedSettings && (
                  <FormControl>
                    <FormLabel id="matchup-algo">
                      Matchup Generation Preference
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="matchup-algo"
                      name="row-balanced-pro"
                      value={matchupAlgo}
                      onChange={(event) => setMatchupAlgo(event.target.value)}
                    >
                      <FormControlLabel
                        value="BALANCED"
                        control={<Radio />}
                        label="Balanced Teams"
                      />
                      <FormControlLabel
                        value="PRO"
                        control={<Radio />}
                        label="Fulfill Pro Requests"
                      />
                    </RadioGroup>
                  </FormControl>
                )}
                {!spreadsheetView && (managerMode === -1 || betaMode) && (
                  <Button
                    variant="outlined"
                    data-testid="refresh-chukkers"
                    onClick={() => {
                      getMatchupFromApi(
                        "generate_matchup_strategy",
                        matchupAlgo,
                        useUSPARating
                      );
                    }}
                  >
                    <SyncIcon />
                    Regenerate Matchup
                  </Button>
                )}
                {/* Warning banners for duplicate players and horses */}
                {!isLoading && !noMatchup && !spreadsheetView && managerMode === -1 && 
                  (duplicateWarnings.duplicatePlayers.length > 0 || duplicateWarnings.duplicateHorses.length > 0) && (
                  <Box sx={{ mb: 2 }}>
                    {duplicateWarnings.duplicatePlayers.length > 0 && (
                      <Alert severity="warning" sx={{ mb: 1 }}>
                        <AlertTitle>Duplicate Players Detected</AlertTitle>
                        {duplicateWarnings.duplicatePlayers.map((warning, idx) => (
                          <Box key={idx} sx={{ mt: 0.5 }}>
                            <strong>Chukker {warning.chukkerId}:</strong> {warning.playerName} appears {warning.count} times
                          </Box>
                        ))}
                      </Alert>
                    )}
                    {duplicateWarnings.duplicateHorses.length > 0 && (
                      <Alert severity="warning">
                        <AlertTitle>Duplicate Horses Detected</AlertTitle>
                        {duplicateWarnings.duplicateHorses.map((warning, idx) => (
                          <Box key={idx} sx={{ mt: 0.5 }}>
                            <strong>Chukker {warning.chukkerId}:</strong> {warning.horseName} is assigned to {warning.count} players
                          </Box>
                        ))}
                      </Alert>
                    )}
                  </Box>
                )}
                {!isLoading && !noMatchup && !spreadsheetView && useNewDashboard && (
                  <ChukkerListDense
                    managerMode={managerMode}
                    chukkerList={listOfChukkers}
                    referenceTeam={moveTeam}
                    referencePlayer={movePlayer}
                    useUSPARating={useUSPARating}
                    proColorMapping={proColorMapping}
                    betaMode={betaMode}
                    chukkerDetails={chukkerDetails}
                    setChukkerDetails={setChukkerDetails}
                    gameDivisions={gameDivisions}
                    devPort={devPort}
                    clubId={clubId}
                    eventId={eventId}
                    eventType="games"
                    updateHorseAssignment={updateHorseAssignment}
                    allHorseAssignments={allHorseAssignments}
                    allPlayerHorses={allPlayerHorses}
                    allClubHorses={allClubHorses}
                  />
                )}
                {!isLoading && !noMatchup && !spreadsheetView && !useNewDashboard && (
                  <ChukkerList
                    managerMode={managerMode}
                    chukkerList={listOfChukkers}
                    referenceTeam={moveTeam}
                    referencePlayer={movePlayer}
                    useUSPARating={useUSPARating}
                    proColorMapping={proColorMapping}
                    betaMode={betaMode}
                    chukkerDetails={chukkerDetails}
                    setChukkerDetails={setChukkerDetails}
                    gameDivisions={gameDivisions}
                  />
                )}
                {!isLoading &&
                  !noMatchup &&
                  !spreadsheetView &&
                  managerMode === -1 && (
                    <Stack direction="row" spacing={2}>
                      <Button
                        variant="outlined"
                        color="primary"
                        data-testid="add-chukker"
                        onClick={createChukker}
                      >
                        <AddIcon />
                        Add Chukker
                      </Button>
                      <Button
                        variant="outlined"
                        color="error"
                        data-testid="delete-chukker"
                        onClick={deleteChukker}
                      >
                        <RemoveIcon />
                        Delete Chukker
                      </Button>
                    </Stack>
                  )}

                {/*!isLoading && !noMatchup && spreadsheetView && false && (
                  <MatchupTable
                    playerList={playerSchedule}
                    chukkerNumber={chukkerNumber}
                    managerMode={managerMode}
                    idMapping={idMapping}
                  />
                )*/}
                {spreadsheetView && unifiedSpreadsheetData && idMapping && (
                  <UnifiedSpreadsheet
                    unifiedSpreadsheetData={unifiedSpreadsheetData}
                    setUnifiedSpreadsheetData={setUnifiedSpreadsheetData}
                    chukkerNumber={chukkerNumber}
                    managerMode={managerMode}
                    idMapping={idMapping}
                    chukkerDetails={chukkerDetails}
                  />
                )}
                {isLoading && <LinearProgress color="secondary" />}
                {!isLoading && noMatchup && (
                  <h3 className={classes.contenth}>
                    No Matchup Generated. You might not have enough players{" "}
                  </h3>
                )}
                {betaMode && (
                  //Clunky. Addind that back for the email table assets
                  <img
                    src={poloMalletLogo}
                    alt="Mallet x"
                    width={30}
                    height={30}
                    sx={{
                      display: {
                        xs: "none",
                        md: "flex",
                      },
                      mr: 1,
                    }}
                  />
                )}
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </DragDropContext>
    </Layout>
  );
}

export default MatchupPage;
